const str = `{HEADER}Copyright Policy
{BODY_TITLE}
Resale of finished products created using VideoMonster's services is prohibited. By clicking "Accept and sign up" you agree to this.
Help VideoMonster keep the good service at the lowest price. Create a healthy content culture together!
`

export default str